exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, ".genepanelsRect{fill:#4e7ad3;pointer-events:all}.genepanelsRect,.grayRect{stroke:#fff;stroke-width:2}.grayRect{fill:#e8ebed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4078f70c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/app/components/viz/SvgBar.vue
// module id = 429
// module chunks = 0